import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-mark-thick",
  "use": "check-mark-thick-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 11\" id=\"check-mark-thick\"><path d=\"M12 2.006L5.187 8.818 2.091 5.722\" stroke=\"currentColor\" stroke-width=\"2.555\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol